import { render, staticRenderFns } from "./ChatGroup.vue?vue&type=template&id=ec24cc7e&scoped=true&"
import script from "./ChatGroup.vue?vue&type=script&lang=js&"
export * from "./ChatGroup.vue?vue&type=script&lang=js&"
import style0 from "./ChatGroup.vue?vue&type=style&index=0&id=ec24cc7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec24cc7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VRow,VTextarea})
